import { Family, FamilyStatus } from "protogen/advisors_service_pb";

export const PREVIEW_DAYS = 21;
export const DIGITAL_PREVIEW_DAYS = 7;

export interface PreviewStatus {
  isUnpaid: boolean;
  daysLeft: number;
  isExpired: boolean;
}

export const getPreviewStatus = (family: Family | undefined): PreviewStatus => {
  if (!family) {
    return { isUnpaid: false, daysLeft: 0, isExpired: false };
  }

  const isUnpaid = family.status === FamilyStatus.UNPAID_SIGNUP;
  if (!isUnpaid) {
    return { isUnpaid: false, daysLeft: 0, isExpired: false };
  }

  const createdDate = new Date(Number(family.createdAtSec) * 1000);
  const now = new Date();
  const diffMs = now.getTime() - createdDate.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const daysLeft = Math.max(0, PREVIEW_DAYS - diffDays);

  return {
    isUnpaid: true,
    daysLeft,
    isExpired: daysLeft <= 0,
  };
};
